import {Component, Injector} from '@angular/core';
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";

@Component({
    selector: 'app-measures',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class MeasuresComponent extends GeneralListComponent {

  constructor(injector: Injector) {
    super(injector);

    this.title = 'MEASURES';
    this.showNewBtn = true;

    this.columns = [
      {id: 'id',label: 'ID', type: ColumnType.Simple},
      {id: 'name',label: 'Név', type: ColumnType.Simple},
      {id: 'unitName',label: 'Mértékegység', type: ColumnType.Simple},
      {id: 'aggregation',label: 'Aggregate', type: ColumnType.Simple},
      {id: 'modified',label: 'Módosítva', type: ColumnType.Simple},
      {id: 'modifiedBy',label: 'Módosította', type: ColumnType.Simple},
      {id: 'action', label: 'edit', type: ColumnType.Action}
    ];
  }

  fetchItems() {
    this.service.getMeasures().subscribe((resp:any) => {
      this.handleFetchResponse(resp)
    })
  }

}
